import { useMemo } from 'react';

import { PromoCodes } from '@ctct/presentation-layer';
import { useIsGuruLiteOfferPartner } from '@ctct/state-server-layer';

import type { PromoCodesWidgetProps } from './usePromoCodesWidget';

export const PromoCodesWidget = (props: PromoCodesWidgetProps) => {
  const { data, hooks, handlers, isCompact, hideButtonWhenInputIsEmpty } = props;
  const { isGuruLiteOfferPartner } = useIsGuruLiteOfferPartner();

  const promoCodesCopy = data.getPromoCodeWidgetCopy();
  const promoCodeErrorMessages = hooks.usePromoCodeFormErrors();
  const validatedPromoCodesData = data.getValidatedPromoCodes();
  const validatedPromoCodes = useMemo(
    () =>
      validatedPromoCodesData.map((code) => ({
        ...code,
        onRemove() {
          handlers.onRemovePromoCodeClick(code.name);
        },
      })),
    [validatedPromoCodesData, handlers]
  );
  const promoCodeTextFieldValue = hooks.usePromoCodeTextFieldValue();

  // Guru Lite: partner promo still auto-applies via the manager; hide the discount UI.
  if (isGuruLiteOfferPartner) {
    return null;
  }

  return (
    <PromoCodes
      copies={promoCodesCopy}
      promoCodes={validatedPromoCodes}
      value={promoCodeTextFieldValue}
      onApply={handlers.submitPromoCode}
      onChange={(changeEvent) => handlers.setPromoCodeTextFieldValue(changeEvent.target.value)}
      errorLabel={promoCodeErrorMessages.at(-1)}
      disableApplying={promoCodeTextFieldValue.trim().length === 0}
      isCompact={isCompact}
      hideButton={hideButtonWhenInputIsEmpty && promoCodeTextFieldValue.trim().length === 0}
    />
  );
};
